/*
 *
 * ReportHome actions
 *
 */

import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER,
  GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS,
  GET_MEASURE_TOTAL_SUB_DIVISION_FAILED,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_SUCCESS,
  GET_MEASURE_INFO_FAILED,
} from "./constants"

export function getStatusWatcher(payload) {
  return {
    type: GET_STATUS_WATCHER,
    payload,
  }
}

export function getStatusSuccess(payload) {
  return {
    type: GET_STATUS_SUCCESS,
    payload,
  }
}

export function getStatusFailed() {
  return { type: GET_STATUS_FAILED }
}

export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

export function getMeasureColorRangeFailed(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_FAILED,
    payload,
  }
}

export function getMeasureTotalWatcher(payload) {
  return {
    type: GET_MEASURE_TOTAL_WATCHER,
    payload,
  }
}

export function getMeasureTotalSuccess(payload) {
  return {
    type: GET_MEASURE_TOTAL_SUCCESS,
    payload,
  }
}

export function getMeasureTotalFailed() {
  return { type: GET_MEASURE_TOTAL_FAILED }
}

export function getMeasureTotalSubDivisionWatcher(payload) {
  return {
    type: GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER,
    payload,
  }
}

export function getMeasureTotalSubDivisionSuccess(payload) {
  return {
    type: GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS,
    payload,
  }
}

export function getMeasureTotalSubDivisionFailed() {
  return { type: GET_MEASURE_TOTAL_SUB_DIVISION_FAILED }
}

export function getMeasureInfoWatcher(payload) {
  return {
    type: GET_MEASURE_INFO_WATCHER,
    payload,
  }
}

export function getMeasureInfoSuccess(payload) {
  return {
    type: GET_MEASURE_INFO_SUCCESS,
    payload,
  }
}

export function getMeasureInfoFailed() {
  return { type: GET_MEASURE_INFO_FAILED }
}
